import React from "react";

import ImageLeftTextRightImageBelowSlice from "../../components/slices/imageLeftTextRightImageBelow/ImageLeftTextRightImageBelowSlice";

const ImageLeftTextRightImageBelow = ({ slice }) => {
  return <ImageLeftTextRightImageBelowSlice slice={slice} />;
};

export default ImageLeftTextRightImageBelow;
